import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/serviceSalesSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const CompareType = () => {
  const dispatch = useDispatch();
  const compareTypes = useSelector((state) => state.serviceSales.compareTypes);
  const selectedCompareTypes = useSelector(
    (state) => state.serviceSales.selectedFilters.compareTypes
  );

  return (
    <MultiSelectDropdown
      filterType="Custom Range"
      options={compareTypes}
      includeFilter={false}
      numberDisplayed={0}
      selectedFilters={selectedCompareTypes}
      enableDefaultSelected
      enableMax
      maxSelect={1}
      haveOnSelectChange={false}
      updateLocations={(data) => dispatch(actionCreators.updateCompareType(data))}
      maxSelected={(data) => dispatch(actionCreators.maxSelected(data))}
    />
  );
};

export default CompareType;
